<template>
  <div>
    <div class="ContainerSearchInput">
      <b-button class="BtnRegister" @click="openModalToReceive">
        <b-icon-plus
          scale="1.5"
          style="
            width: 30px;
            background: #006458;
            height: 30px;
            color: white;
            border-radius: 3px;
          "
        ></b-icon-plus>
        <span style="width: 170px">Novo Cliente</span>
      </b-button>
      <div class="searchInput">
        <b-form-select
          v-if="showFilterTypes"
          id="filterType"
          class="searchFilterTypes"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="filterType"
          :options="filterTypes"
        ></b-form-select>

        <b-form-select
          class="searchFilter"
          :style="
            showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
          "
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
          @change="handleShowFilterTypes"
        ></b-form-select>

        <b-input
          size="sm"
          placeholder="Pesquisar"
          v-model="textPesquisa"
          class="inputSearch"
          @keyup.enter="readCustomers(page)"
        ></b-input>

        <b-button size="sm" @click="readCustomers(page)" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
        <!-- <div class="searchInputAll" style="justify-content: flex-end">
          <button class="searchAll" @click="readCustomers(page)">
            ver tudo
          </button>
        </div> -->
      </div>
      <div class="contentTexts">
        <div class="textRegister">
          <span>
            <b-icon-people-fill class="mr-1" />Clientes Registrados -
            {{ this.counter.customersCount }}</span
          >
        </div>
        <div class="textRegister" style="padding-right: 10px">
          <span>
            <b-icon-house-door-fill class="mr-1" />Propriedades Registrados -
            {{ this.counter.propertiesCount }}</span
          >
        </div>
      </div>
    </div>
    <div
      class="ContentTable"
      v-if="this.dataLength > 0"
      style="color: #3a4750; width: 100%"
    >
      <div class="headerTable">
        <div class="celTable" style="width: 5%; text-align: center">Cód</div>
        <div class="celTable" style="width: 30%">Nome</div>
        <div class="celTable" style="width: 20%">CPF/CNPJ</div>
        <div class="celTable" style="width: 20%">Cidade/UF</div>
        <div class="celTable" style="width: 20%">Contato</div>
        <div class="celTableActions" style="width: 5%">Ações</div>
      </div>
      <div
        v-for="customer in customers"
        :key="customer.id"
        @click="detailsCliente(customer)"
        class="rowCLient"
      >
        <div class="celTable" style="width: 5%">
          <span
            style="
              color: #006458;
              font-weight: bold;
              text-transform: uppercase;
              font-size: 12px;
            "
            >{{ customer.codigo }}
          </span>
        </div>
        <div
          class="celTable"
          style="
            width: 30%;
            color: #006458;
            font-weight: bold;
            text-transform: uppercase;
            padding-left: 3px;
          "
        >
          {{ customer.nome }}
        </div>
        <div class="celTable" style="width: 20%">
          {{ customer.cpfCnpj || "000.000.00-00" }}
        </div>
        <div class="celTable" style="width: 20%">
          {{ customer.cidade || "--" }} - {{ customer.uf }}
        </div>
        <div v-if="customer.celular" class="wtsTd" style="width: 20%">
          {{ customer.celular || "(00) 0000-0000" }}
          <img
            class="whatsapp"
            :src="whatsapp"
            @click="redirectWhatsApp(customer.celular)"
          />
        </div>
        <div v-else class="celTable" style="width: 20%">
          {{ customer.telefone || "--" }}
        </div>
        <div class="celTableActions" style="justify-content: flex-end">
          <span
            v-b-tooltip.hover.top="'Excluir'"
            class="celInfos"
            @click.stop="handleOpenModal(customer.id)"
            ><b-icon-trash-fill scale="1.5"
          /></span>
        </div>
      </div>
    </div>
    <div v-else class="defaultSearch">
      <span>Não há dados para exibir ...</span>
    </div>
    <div v-if="spinGeneral" class="loadingLazy">
      <div class="loader"></div>
    </div>
    <div class="setBtn">
      <button @click="previousPage" :disabled="page === 1" class="itemBtn">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button @click="nextPage" :disabled="this.dataLength < 9" class="itemBtn">
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>

    <ModalConfirm
      modalName="modal-confirm-delete"
      title="Remover Cliente"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="destroyCustomer"
      @modalClosed="selectedCustomerId = null"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import searchCustomer from "../../mixins/Customer/Search";

import serviceCustomer from "../../services/serviceCustomer";
import serviceRegisters from "../../services/serviceRegisters";

import whatsapp from "../../assets/whatsapp.svg";
export default {
  props: {
    getAllCustomer: {
      type: Boolean,
    },
  },
  mixins: [searchCustomer],

  data() {
    return {
      counter: {},
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      customers: [],
      page: 1,
      whatsapp: whatsapp,
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "celular", text: "Contato" },
        { value: "status", text: "Status" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "includes",
      showFilterTypes: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_CUSTOMER",
    ]),
    async findById(client) {
      try {
        const result = await serviceCustomer.findById(client.id);
        this.openModalToReceive(result);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },

    // async findCustomerSales() {
    //   this.customerSales = await serviceSale.findCustomerSales(
    //     this.dataSearchCustomer.id,
    //     1
    //   );
    // },

    // async findCustomerBills() {
    //   this.customerBills = await serviceBill.findCustomerBills(
    //     this.dataSearchCustomer.id,
    //     1
    //   );
    // },

    async detailsCliente(client) {
      try {
        const result = await serviceCustomer.findById(client.id);

        this.openModalDetails(result);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um eror ao buscar o cliente!",
            type: "error",
          });
        }
      }
    },

    openModalToReceive(customers) {
      this.SET_DATA_SEARCH_FROM_CUSTOMER(customers);

      const name = "customer";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    openModalDetails(detailsCustomer) {
      this.SET_DATA_SEARCH_FROM_CUSTOMER(detailsCustomer);

      this.ALTER_TYPE_REGISTER("customer");
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
    },

    handleShowFilterTypes() {
      const types = ["nome", "cpfCnpj", "celular", "endereco", "cidade", "cep"];

      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }

      this.showFilterTypes = false;
    },
    async countAll() {
      try {
        this.counter = await serviceRegisters.countAll();
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  computed: {
    ...mapState({
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
  },
  watch: {
    async getAllCustomer() {
      await this.readCustomers(1);
    },
    isSearchRegisters() {
      this.readCustomers();
    },
  },
  created() {
    this.countAll();
  },
};
</script>

<style scoped>
.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 5px;
  width: 100%;
  max-width: 100%;
  height: 70vh;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowCLient {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid #e3ebe2;
  border-radius: 2px;
  text-align: center;
  height: 40px;
  padding: 0 10px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowCLient:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableInfos {
  display: flex;
  gap: 10px;
  width: 20%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  background: #e3ebe2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 30px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: #006458;
}
.celTableActions {
  display: flex;
  width: 5%;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.countItem {
  width: 20px;
  border-radius: 5px;
  background-color: rgb(0, 81, 169);
  color: white;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

.notResult {
  max-height: 50px;
  border-radius: 50%;
  max-width: 50px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 29px;
}

.trTable {
  text-align: center;
  height: 29px;
  cursor: context-menu;
  font-size: 12px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

tbody tr:hover {
  background: rgb(194, 193, 193);
  cursor: pointer;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.wtsTd {
  display: flex;
  gap: 2px;
  cursor: pointer;
  text-align: center;
  justify-content: center;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilterTypes {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilterTypes:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  gap: 10px;
  justify-content: space-between;
  padding: 0 0px;
}

.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.contentTexts {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 20px;
  padding-right: 10px;
}
.textRegister {
  display: flex;
  align-items: center;
  height: 100%;
  border-left: 1px solid #e1e1e1;
  padding-left: 10px;
}
.textRegister span {
  color: #006458;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchInput {
  width: 40%;
  display: flex;
}

.searchInputAll {
  width: 50%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 10px 10px 0;
  gap: 5px;
  bottom: 0;
  right: 0;
  justify-content: flex-end;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #006458;
}

.itemBtn:hover {
  background: #006458;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 3px;
  color: #ffffff;
  cursor: auto;
  background: #006458;
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #006458;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #0051a9;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding: 3px;
  }
  .textRegister {
    font-size: 12px;
  }
  .searchInput {
    width: 60%;
  }
  .searchFilter {
    height: 25px;
    font-size: 11px;
  }
  .form-control-sm {
    padding: 0.25rem 1.2rem;
    height: 25px;
    font-size: 12px;
  }
  .searchBtn {
    right: 10px;
    height: 25px;
    display: flex;
    align-items: center;
  }
  .searchAll {
    font-size: 11px;
    padding: 2px 10px;
  }
  .ContentTable {
    height: 50vh;
    max-height: 50vh;
    padding: 5px;
  }
  .headTable {
    height: 25px;
  }
  .trTable {
    height: 25px;
    font-size: 11px;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    display: flex;
    align-items: center;
    height: 70px;
    gap: 5px;
    width: 100%;
    justify-content: center;
    padding: 0;
    flex-direction: column;
  }

  .searchInput {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 3px 0 0;
  }

  .searchInputAll {
    width: 150px !important;
  }

  .rowCLient {
    gap: 5px;
    padding: 2px 5px;
    font-size: 10px;
    border-left: 5px solid rgb(64, 59, 116) !important;
  }

  .celTableInfos {
    display: none;
  }

  .celTable {
    width: 33% !important;
  }

  .ContentTable {
    padding: 5px;
    overflow: auto;
    gap: 2px;
  }

  .notResult {
    display: none;
  }

  .trTable {
    font-size: 9px;
  }

  .whatsapp {
    display: none;
  }

  .searchAll {
    font-size: 10px;
    padding: 5px 10px;
  }

  .form-control-sm {
    padding: 0.25rem 0.5rem !important;
    font-size: 10px;
  }

  .searchFilter {
    width: 100px;
    font-size: 10px;
  }
}
</style>